import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Button, Card, Pagination, Row, Col, Spin } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import moment from 'moment';

const InvoiceItemsModal = ({
  open,
  onCancel,
  invoiceItems,
  handleDownload,
  handlePageChange,
  currentItemsPage,
  itemsPerPage,
  itemsLoading,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      title={t('subscriptions.invoiceItems')}
      open={open}
      onCancel={onCancel}
      width={600}
      footer={false}
    >
      <Spin spinning={itemsLoading}>
        <Row>
          {invoiceItems.items?.length > 0 && (
            <Col xs={24}>
              <Button
                onClick={handleDownload}
                style={{ float: 'right', marginBottom: '15px' }}
                icon={<DownloadOutlined />}
              >
                {t('subscriptions.downloadCSV')}
              </Button>
            </Col>
          )}

          <Col xs={24}>
            {invoiceItems.items?.length === 0 ? (
              <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <h3>{t('subscriptions.noItemsAvailable')}</h3>
              </div>
            ) : (
              <>
                <div
                  className="items-container"
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(1, 1fr)',
                    gap: '16px',
                  }}
                >
                  {invoiceItems.items?.map((item) => (
                    <Card key={item.id} title={item.note} bordered>
                      <div>
                        <strong>{t('subscriptions.credits')}:</strong>{' '}
                        {item.credits || 0}
                      </div>
                      <div>
                        <strong>{t('subscriptions.createdAt')}:</strong>{' '}
                        {moment(item.createdAt).format('YYYY-MM-DD HH:mm')}
                      </div>
                      <div>
                        <strong>
                          {t('subscriptions.vehicle')}: {item.vehicle?.vehicleMake?.name}{' '}
                          {item.vehicle?.vehicleModel?.name}{' '}
                        </strong>
                      </div>
                      <div>
                        <strong>{t('subscriptions.vin')}: {item.vehicle?.vin || '/'}</strong>
                      </div>
                      <div>
                        <strong>
                          {item.user?.role?.name === 'user'
                            ? `${t('roles.user')}`
                            : item.user?.role?.name === 'carHouseAdmin'
                            ? `${t('roles.admin')}`
                            : item.user?.role?.name}
                          : {item.user?.firstName} {item.user?.lastName}
                        </strong>
                      </div>
                    </Card>
                  ))}
                </div>

                <Pagination
                  current={currentItemsPage}
                  pageSize={itemsPerPage}
                  total={invoiceItems.count}
                  onChange={handlePageChange}
                  style={{ marginTop: '16px', textAlign: 'center' }}
                />
              </>
            )}
          </Col>
        </Row>
      </Spin>
    </Modal>
  );
};

export default InvoiceItemsModal;
